
import { Popover } from "element-ui"
import dayjs from "dayjs"
import debounce from "lodash/debounce"
import breadcrumb from "../library/breadcrumb.vue"
import proRec from "../components/proRec.vue"
import {
  priceFormat,
  priceFormatOther,
  getCartCheckedCount,
  openNoAddressPop,
  noAddressCheck,
  getStockMax,
  formatWareImgUrl,
  appendUrlParams,
  redirectToLoginPage,
  customSkuKey,
  showGlobalMessage
} from "../utils/utils"
import inputNumber from "../components/cms/inputNumber.vue"
import picZoom from "../components/picZoom/picZoomProduct.vue"
import collectOrder from "../components/drawer/collectOrder.vue"
import { getProductDetail, getProductDetailSpu } from "../api/gateway"
import spuAttributes from "../components/drawer/components/spuAttributes.vue"
import Storage from "@/utils/storage"
import getCartNumMixin from "@/mixins/getCartNum"
import collapseTransition from "@/library/collapse-transition.js"
import tooltip from "@/components/tooltip.vue"
import commonConfig from "@/utils/common"
import { trackViewItem, trackAddToCart, handleChangeCartNumber } from "@/utils/track"
import { getHeadLink, getHeadMeta } from "@/utils/head"
import { handleAddToCartV2, handleModifyCartV2, handleGetCartDetailV2, getWareBySkuId } from "@/utils/cartResponse"
import { getRequestHeaders, getLoginStatus, formatProductParamsBy } from "@/utils/utils"
import { Logger } from "@/plugins/logger"
import { WARE_STATUS } from "@/constants/ware"
import "dayjs/locale/zh-cn"
import { getLanguage } from "@/plugins/i18n"
import inputNumberSpu from "@/components/drawer/components/inputNumber.vue"
import emptyImg from "@/assets/images/empty_img.png"
import { trackSharePDPLink } from "@/utils/track/share"
import customContent from "@/components/customContent.vue"
//  <!-- 0-正常， 1-售罄， 2-下架, 9-黑名单, 5-商品不存在， -1 CommingSoon， 10-异常，但不展示文案 -->
/**
 * 获取URL参数
 */
const getURLParams = ({ query, params }) => {
  const { sku, skuId, spuPart } = Object.assign(query, params)
  return {
    skuId: sku || skuId,
    spuId: spuPart
  }
}
const baseInfoFormat = data => {
  const baseInfo = data.baseInfo
  baseInfo.showSoldOut = [WARE_STATUS.OUT_OF_STOCK].includes(baseInfo.wareStatus)
  baseInfo.discontinued = [WARE_STATUS.DISCONTINUED].includes(baseInfo.wareStatus)
  baseInfo.comingSoon = baseInfo.wareStatus == WARE_STATUS.COMING_SOON
  const extendInfo = data.extendInfo

  const thresholdInfo = data.thresholdInfo || {}
  const defaultImg = baseInfo?.wareImgListNew?.[0]?.url
  const configData = data.wareRec || []
  const amount = baseInfo.promotionWareVO
    ? priceFormat(baseInfo.promotionWareVO.unitProPrice)[0] +
      "." +
      priceFormat(baseInfo.promotionWareVO.unitProPrice)[1]
    : baseInfo.warePrice
      ? priceFormat(baseInfo.warePrice)[0] + "." + priceFormat(baseInfo.warePrice)[1]
      : ""
  baseInfo.wareImgListNew = baseInfo.wareImgListNew.map(item => {
    item.url = item.url ? item.url : emptyImg
    return item
  })
  return {
    baseInfo,
    extendInfo,
    thresholdInfo,
    defaultImg,
    configData,
    amount,
    skuId: baseInfo.sku
  }
}
const fetchData = async context => {
  const { route, req, error, store, $cookies } = context
  try {
    const urlParams = getURLParams(route)
    const parame = {
      skuId: route.params.sku,
      spuId: route.params.spuPart
    }

    const { data } = await getProductDetail(
      {
        param: formatProductParamsBy(urlParams, $cookies),
        comm: {}
      },
      {
        loading: true,
        headers: getRequestHeaders({ req, store })
      }
    )
    const baseData = baseInfoFormat(data)
    let spuData = {}
    if (baseData.baseInfo.spuId) {
      const param = { skuId: urlParams.skuId, spuId: baseData.baseInfo.spuId, lastSkuId: "" }
      const spuRes = await getProductDetailSpu(
        {
          param: formatProductParamsBy(param, $cookies),
          comm: {}
        },
        {
          loading: true,
          headers: getRequestHeaders({ req, store })
        }
      )
      spuData = spuRes.data
    }
    return {
      ...baseData,
      spuData,
      lang: store.state.lang == "en_US" ? "en" : "zh-hant",
      fullPath: route.fullPath
    }
  } catch (err) {
    Logger.error(`商详初始化报错: ${route.fullPath}`, err)
    error({
      statusCode: 500,
      message: "Internal Server Error"
    })
  }
}
export default {
  components: {
    [Popover.name]: Popover,
    breadcrumb,
    collapseTransition,
    inputNumber,
    inputNumberSpu,
    proRec,
    picZoom,
    collectOrder,
    tooltip,
    spuAttributes,
    customContent
  },
  mixins: [getCartNumMixin],
  validate({ query, params }) {
    return query.skuId || params.sku
  },
  async asyncData(context) {
    const { spuData, baseInfo, extendInfo, thresholdInfo, defaultImg, configData, amount, skuId, lang, fullPath } =
      await fetchData(context)
    return {
      fetched: true,
      baseInfo,
      extendInfo,
      spuData,
      thresholdInfo,
      defaultImg,
      configData,
      skuId,
      amount,
      lang,
      fullPath
    }
  },

  data() {
    return {
      fetched: false,
      breadcrumbData: [],
      extendInfo: {},
      thresholdInfo: {},
      defaultImg: "",
      configData: [],
      baseInfo: {},
      scroll: null,
      showDes: true,
      freshnessTitle: "",
      freshnessInfo: "",
      addCartCount: 0,
      commonReqParams: {},
      cartList: [],
      collectOrderCartList: [],
      collectOrderItem: {},
      skuId: "",
      stock: "",
      amount: "",
      lang: "",
      fullPath: "",
      timer: null,
      items: Array.from({ length: 12 }, (_, i) => `Item ${i + 1}`),
      goodsChange: {},
      spuData: {}, // SPU
      currCount: 1, // 准备加入购物车的数量
      customValue: "defaultOption",
      customText: "",
      curRemainingMaxCount: null
    }
  },
  head() {
    return {
      title: `${this.baseInfo.wareName}`,
      meta: [
        { hid: "description", name: "description", content: `${this.baseInfo.wareName}` },
        { name: "og:type", content: "product" },
        { name: "og:title", content: `${this.baseInfo.wareName}` },
        { name: "og:description", content: `${this.baseInfo.wareName}` },
        { name: "og:image", content: this.defaultImg },
        { name: "product:price:amount", content: this.amount },
        { name: "product:price:currency", content: "HKD" },
        ...getHeadMeta(this)
      ],
      link: getHeadLink(this),
      script: [
        {
          hid: "ldjson-schema",
          type: "application/ld+json",
          innerHTML: `
          {
            "@context": "http://schema.org",
            "@type": "Product",
            "name": "${this.baseInfo.wareName}",
            "description": "${this.baseInfo.wareName}",
            "image": "${this.defaultImg}",
            "brand": {
              "@type": "Brand",
              "name": "${this.baseInfo.brandName || ""}"
            },
            "offers": {
              "@type": "Offer",
              "price": "${this.amount}",
              "priceCurrency": "HKD"
            }
          }
        `
        }
      ]
    }
  },
  computed: {
    sizeLineShow() {
      const { preOrderSaleStart, preOrderPickUpPeriod, deliveryPeriod, deliveryMethod } = this.baseInfo
      return preOrderSaleStart || preOrderPickUpPeriod || deliveryPeriod || deliveryMethod !== null
    },
    customContentConfig() {
      return this.baseInfo?.preferenceList?.find(item => item.preferenceKey === customSkuKey)
    },
    customDisabledText() {
      if (this.baseInfo.inBlackList) {
        return this.$t("sku.outOfStock")
      } else if (this.baseInfo.wareStatus == 0 && this.showNotAvailable(this.baseInfo) === "Y") {
        return this.$t("sku.outOfStock")
      } else if (this.baseInfo.wareStatus == -1) {
        return this.$t("sku.commingSoon")
      } else if (this.baseInfo.wareStatus == 1) {
        return this.$t("sku.soldOut")
      } else if (this.baseInfo.wareStatus == 2) {
        return this.$t("sku.takeDown")
      } else if (this.baseInfo.wareStatus == 9 || this.baseInfo.wareStatus == 5) {
        return this.$t("sku.outOfStock")
      } else {
        return this.$t("sku.soldOut")
      }
    },
    remainingMaxCount() {
      return this.curRemainingMaxCount !== null ? this.curRemainingMaxCount : -1
    }
  },
  created() {
    if (!process.client) {
      return
    }
    this.freshnessTitle = this.$t("productDetails.freshnessTitle")
    this.freshnessInfo = this.$t("productDetails.freshnessInfo", {
      num: this.baseInfo.freshness
    })

    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams

    trackViewItem(this.baseInfo)
  },

  async mounted() {
    this.initBreadcrumb()
    const { isOnline } = getLoginStatus()
    this.$bus.$off("add-cart-success")
    this.$bus.$on("add-cart-success", () => {
      this.$nextTick(async () => {
        const loading = this.$loading({
          background: "rgba(0, 0, 0, 0)"
        })
        await handleGetCartDetailV2()
        loading.close()
      })
    })
    this.$bus.$off("getCartSkuList", this.init)
    // 组装当前商品已加购数据 和 推荐商品已加购数据
    this.$bus.$on("getCartSkuList", this.init)
    if (!this.fetched) {
      const { baseInfo, extendInfo, thresholdInfo, defaultImg, configData, amount, skuId, lang, fullPath } =
        await fetchData(this.$nuxt.context)
      this.baseInfo = baseInfo
      this.extendInfo = extendInfo
      this.thresholdInfo = thresholdInfo
      this.defaultImg = defaultImg
      this.configData = configData
      this.skuId = skuId
      this.amount = amount
      this.lang = lang
      this.fullPath = fullPath
      //   if (this.baseInfo.comingSoon) {
      //     if (this.timer) {
      //       clearInterval(this.timer)
      //     }
      //     let time = baseInfo.preOrderSaleStart && baseInfo.preOrderSaleStart - new Date().getTime()
      //     if (time && time > 0) {
      //       time = time / 1000
      //       this.timer = setInterval(() => {
      //         time = time - 1
      //         if (time <= 0) {
      //           clearInterval(this.timer)
      //           this.baseInfo.comingSoon = false
      //         }
      //       }, 1000)
      //     }
      //   }
    }
    if (isOnline) {
      await handleGetCartDetailV2()
    }
  },
  methods: {
    priceFormat,
    priceFormatOther,
    getStockMax,
    init(val) {
      this.cartList = val
      const selWares = {}
      const curSku = this.baseInfo.sku
      this.cartList.forEach(item => {
        selWares[item.sku] = { count: item.count, stock: item.stock, remainingMaxCount: item.remainingMaxCount }
      })
      const target = this.cartList.find(item => item.sku == curSku)
      this.addCartCount = target ? target.count : 0
      this.stock = target ? target.stock : 0
      this.curRemainingMaxCount = target ? target.remainingMaxCount : null
      this.configData.forEach(ware => {
        if (selWares[ware?.additional?.sku]) {
          this.$set(ware, "addCartCount", selWares[ware.additional.sku].count)
          this.$set(ware, "stock", selWares[ware.additional.sku].stock)
          this.$set(ware, "remainingMaxCount", selWares[ware.additional.sku].remainingMaxCount)
        } else {
          this.$set(ware, "addCartCount", 0)
        }
      })
    },
    initBreadcrumb() {
      const whereFrom = {
        name: this.$t("common.home"),
        path: this.MAIN_ORIGIN_HOME
      }
      const selPath = [{ name: this.baseInfo.wareName }]
      this.breadcrumbData = [whereFrom, ...selPath]
    },

    titleClick() {
      this.showDes = !this.showDes
    },

    resetCustomConfig() {
      this.$nextTick(() => {
        this.$refs?.customContent?.reset()
      })
    },
    updateCustomValue(value) {
      this.customValue = value
    },
    updateCustomText(value) {
      this.customText = value
    },
    async handleAddClick(item) {
      // if (noAddressCheck()) {
      //   openNoAddressPop()
      //   return
      // }currCount

      if (this.customContentConfig && this.customValue === "customOption" && !this.customText) {
        return
      }

      const [error, data, wareList] = await handleAddToCartV2({
        // TODO storeId
        storeId: this.commonReqParams.storeId,
        wares: [{ sku: item.sku, beforeCount: 0, count: this.currCount, checked: 1 }],
        sort: 1,
        otherParams: this.customContentConfig
          ? {
              customisationList: [
                {
                  count: this.currCount,
                  checked: 1,
                  remarkReq: this.customValue === "defaultOption" ? "Default" : this.customText,
                  remarkType: this.customValue
                }
              ]
            }
          : {}
      })
      if (data) {
        const curCartWare = getWareBySkuId(data, item.sku) || {}
        this.curRemainingMaxCount = curCartWare.remainingMaxCount
        if (data.overToast) {
          showGlobalMessage({
            message: data.overToast,
            gap: 14,
            iconClass: "alert-info"
          })
          return
        }
        this.currCount = 1
        this.addCartCount = 1
        this.cartList = wareList
        const curWare = wareList.find(ware => ware.sku === item.sku) || {}
        this.stock = curWare.stock
        this.$message({ message: this.$t("productDetails.addCartSuccessful"), type: "success", duration: 1000 })
      } else {
        this.addCartCount = 0
        if (error.data) {
          this.currCount = error.data
        }
      }
      trackAddToCart(this.baseInfo)
    },
    breadcrumbClick(item) {
      return item.params ? `${this.MAIN_PATH}/category/${item.params.split(",").join("-")}/1.html` : `${this.MAIN_PATH}`
    },
    isNotSingleAndOrder(item) {
      return item.proType !== "UNIT" && item.proType !== "BASKET"
    },
    handleOfferClick(item) {
      if (!this.isNotSingleAndOrder(item)) {
        return
      }
      this.collectOrderCartList = this.cartList.map(item => ({
        sku: item.skuId,
        skuId: item.skuId,
        count: item.count,
        stock: item.stock
      }))

      this.handleOpenCollect(item)
    },
    handleOpenCollect(val) {
      const bestOffer = val.isBestoffer
      const params = {
        bestOffer
      }
      params.promotionId = val.proId
      params.skuId = this.skuId
      try {
        const tempObj = JSON.parse(val.displayInfo.proActUrl)
        params.title = tempObj.mTitle
        params.storeId = tempObj.mStoreId
      } catch (error) {
        console.log(error)
      }
      this.$refs.collectOrder.open(params)
    },
    handleNumChange(count, wareList) {
      handleChangeCartNumber(count, this.addCartCount, this.baseInfo)
      this.addCartCount = count
      this.cartList = wareList
      this.curRemainingMaxCount = wareList.find(ware => ware.sku === this.baseInfo.sku)?.remainingMaxCount
    },
    handleCopyUrl: debounce(function () {
      const { custId } = Storage.get("accountInfo", { useBase64: true }) || {}
      trackSharePDPLink({
        wareName: this.baseInfo.wareName,
        wareId: this.baseInfo.wareId,
        userId: custId
      })
      const { isOnline } = this.$utils.getLoginStatus()
      if (!isOnline) {
        redirectToLoginPage()
        return
      }
      const urlParams = {
        utm_source: "Share",
        utm_medium: "7EHK_web",
        utm_campaign: "PDP",
        u: custId || "",
        storeId: this.commonReqParams.storeId,
        venderId: this.commonReqParams.venderId,
        storeType: 1,
        needJumpHome: 1
      }
      const url = appendUrlParams(window.location.href, urlParams)
      this.$copyText(url).then(res => {
        this.$message({ message: this.$t("common.shareWithCopyText"), type: "success", duration: 1000 })
      })
    }, 500),
    singleGiftOrRedeemItem(item) {
      let result
      const optTradeSkus = (item.tradeGoods && item.tradeGoods.optTradeSkus) || []
      const optGiftSkus = (item.giftGoods && item.giftGoods.optGiftSkus) || []

      // 不判断类型，只判断这两个个数相加等于1的时候才显示(保持跟app一样的逻辑处理)
      if (optTradeSkus.length + optGiftSkus.length === 1) {
        if (optTradeSkus.length) {
          result = optTradeSkus[0]
          if (result) {
            result._type = "trade"
          }
        } else if (optGiftSkus.length) {
          result = optGiftSkus[0]
          if (result) {
            result._type = "gift"
          }
        }
      }

      return result
    },
    soldOut(item) {
      const target = this.singleGiftOrRedeemItem(item)
      if (!target) {
        return false
      }

      return [1, 2].includes(target.skuTradeStatus)
    },
    multipleGifts(item) {
      return item.giftGoods && item.giftGoods.autoGift
    },
    multipleGiftsOrRedeemItemList(item) {
      const optTradeSkus = (item.tradeGoods && item.tradeGoods.optTradeSkus) || []
      const optGiftSkus = (item.giftGoods && item.giftGoods.optGiftSkus) || []
      optTradeSkus.forEach(item => (item._type = "trade"))
      optGiftSkus.forEach(item => (item._type = "gift"))
      return [...optTradeSkus, ...optGiftSkus]
    },
    multipleSoldOut(item) {
      return [1, 2].includes(item.skuTradeStatus)
    },
    giftClick(item) {
      this.$navigation.push(
        `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${item.skuId}&name=${encodeURIComponent(
          item.skuName
        )}`
      )
    },
    removeGMTFromISO(time) {
      if (!time) {
        return ""
      }
      let date = ""
      if (getLanguage() == "zh_HK") {
        // eslint-disable-next-line import/no-named-as-default-member
        dayjs.locale("zh-cn")
        date = dayjs(time).format("YYYY年MM月DD日 HH:mm")
      } else {
        date = dayjs(time).format("D MMM YYYY HH:mm")
      }

      return date
    },
    handleComingSoonClick() {
      this.$message({
        type: "info",
        message: this.$t("common.comingSoon")
      })
    },
    showNotAvailable(baseInfo) {
      const { merchantId } = baseInfo
      if (process.client) {
        const { provincial } = JSON.parse(localStorage.getItem("curSelStore") || "{}")
        return merchantId !== 2 && provincial && provincial !== { 0: 810000, 1: 820000 }[merchantId] ? "Y" : "N"
      }
      return ""
    },
    displayInfoProInfo(item) {
      let displayInfo = ""
      const code = this.lang == "en" ? ", " : "；"
      displayInfo = item.displayInfo.proSlogan ? item.displayInfo.proSlogan : ""
      displayInfo = item.displayInfo.proLimitDesc ? displayInfo + code + item.displayInfo.proLimitDesc : displayInfo
      displayInfo = item.displayInfo.disclaimerDesc ? displayInfo + code + item.displayInfo.disclaimerDesc : displayInfo
      return displayInfo
    },
    fetchClick(obj) {
      this.fetchData(obj.additional, obj.sku)
    },

    // 获取商品详情
    async fetchData(val, changeSku = null) {
      const currSskuId = !changeSku ? val.sku : changeSku?.skuId
      if (currSskuId == this.skuId) return

      this.resetCustomConfig()

      const preorderStoreId = this.$cookies.get("pickUpStoreId")
      let attrList = []
      if (changeSku) {
        attrList = changeSku?.spuAttributeInfos.map(item => {
          return {
            attrId: item.attrId,
            attrValueId: item.attrValueId
          }
        })
      }
      try {
        const resData = await getProductDetailSpu(
          {
            param: {
              preorderStoreId,
              skuId: currSskuId,
              spuId: val.spuId,
              lastSkuId: this.skuId,
              attrList
            },
            comm: {}
          },
          {
            loading: true
          }
        )
        this.spuData = resData.data
        const { data } = await getProductDetail(
          {
            param: {
              preorderStoreId,
              skuId: this.spuData.currentSku.skuId,
              spuId: val.spuId
            },
            comm: {}
          },
          {
            loading: true
          }
        )
        const { baseInfo, extendInfo, thresholdInfo, defaultImg, configData, amount, skuId } = baseInfoFormat(data)
        this.baseInfo = baseInfo
        this.extendInfo = extendInfo
        this.thresholdInfo = thresholdInfo
        this.defaultImg = defaultImg
        this.configData = configData
        this.amount = amount
        this.skuId = skuId
        this.currCount = 1
      } catch (err) {}
    },

    // 商品加购,后期可能埋点处理
    handleChange(count) {
      this.currCount = count
    },
    imageUrl(url) {
      if (url) {
        return formatWareImgUrl(url)
      }
      return emptyImg
    }
  }
}
